import { Typography, withStyles } from '@material-ui/core';
import { animated as a } from 'react-spring';

export const AnimatedTypography = a(Typography);


export const TitleTypo = withStyles(() => ({
    root: {
        color: '#FFF'
    }
}))((props: any) => <Typography variant="h5" {...props} />);
export const GreenTitleTypo = withStyles((theme) => ({
    root: {
        color: (theme.palette.primary as any)['200']
    }
}))(TitleTypo);

export const PlaceholderText = ({height}:any) =>( <AnimatedTypography style={{ height, width: 1 }} />);
